import { Storage } from '../lib/storage';
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, Navigation, Share2, Users, Lock, Calendar, Edit3, Gift, Copy, CheckCircle, MessageCircle, AlertTriangle, Clock, X, Trash2, Search, Crown, Maximize2, Map, Shield, RefreshCw, Bike, ChevronRight } from 'lucide-react';
import { supabase } from '../lib/supabase';
import routeBanner from '../assets/route_banner_mountain.png';
import routeDetailRecord from '../assets/route_detail_record.png';

export default function DestinosScreen() {
  const [modoRuta, setModoRuta] = useState<'lista' | 'crear' | 'ver' | 'editar'>('lista');
  const [codigoCopiado, setCodigoCopiado] = useState(false);
  const [mostrarParche, setMostrarParche] = useState(false);
  const [rutaSeleccionada, setRutaSeleccionada] = useState<any>(null);
  const [busquedaParche, setBusquedaParche] = useState('');
  const [filtroOro, setFiltroOro] = useState(false);
  const [dialogoConfirmacion, setDialogoConfirmacion] = useState<{titulo?: string, mensaje: string, color?: 'red' | 'emerald', botonTexto?: string, accion: () => void} | null>(null);
  const [cargandoRutas, setCargandoRutas] = useState(false);
  const [guardandoRuta, setGuardandoRuta] = useState(false);
    
  // BROADCAST AL PARCHE
  const [mostrarBroadcast, setMostrarBroadcast] = useState(false);
  const [mensajeBroadcast, setMensajeBroadcast] = useState('');
  const [enviandoBroadcast, setEnviandoBroadcast] = useState(false);
  
  // NUEVOS ESTADOS DE ASISTENCIA A LA RUTA
  const [asistentesRuta, setAsistentesRuta] = useState<any[]>([]);
  const [mostrarAsistentes, setMostrarAsistentes] = useState(false);
  const [mapType, setMapType] = useState('m');
  const [mapaCompleto, setMapaCompleto] = useState(false);
  
  // Conexión Viva a Supabase para cargar el Parche
  
  
  const capitalizarPalabras = (str: string) => {
    return str
      .split(' ')
      .map(word => word ? word.charAt(0).toUpperCase() + word.slice(1) : '')
      .join(' ');
  };

  const [codigoReferido, setCodigoReferido] = useState("");

  React.useEffect(() => {
    const fetchCodigo = async () => {
      let codigo = Storage.get('gravity_codigo') || Storage.get('gravity_mi_codigo_referido');
      if (!codigo) {
        const myId = Storage.get('gravity_user_id');
        if (myId) {
          try {
            const { data } = await supabase.from('usuarios').select('codigo_referido').eq('id', myId).single();
            if (data && data.codigo_referido) {
              codigo = data.codigo_referido;
              Storage.set('gravity_codigo', codigo);
            }
          } catch(e) {}
        }
      }
      
      if (!codigo) {
        const randStr = Math.random().toString(36).substring(2, 6).toUpperCase();
        let prefijo = 'MOTE';
        const aliasRaw = Storage.get('gravity_alias') || Storage.get('gravity_nombre_perfil') || '';
        if (aliasRaw) {
          prefijo = aliasRaw.split(' ')[0].toUpperCase().replace(/[^A-Z]/g, '').substring(0, 5) || 'MOTE';
        }
        codigo = `PIKIS-${prefijo}-${randStr}`;
        Storage.set('gravity_codigo', codigo);
      }
      setCodigoReferido(codigo);
    };
    fetchCodigo();
  }, []);

  const [rutaIdEdicion, setRutaIdEdicion] = useState<string | null>(null);
  const [rutaForm, setRutaForm] = useState({
    nombre: '',
    puntoEncuentro: '',
    ciudad: '',
    sena: '',
    destino: '',
    fecha: '',
    hora: '',
    privacidad: 'publica', 
    cilindraje: 'todos', 
  });

  const [rutasGuardadas, setRutasGuardadas] = useState<any[]>([]);
  const [mostrarSelectorCC, setMostrarSelectorCC] = useState(false);

  React.useEffect(() => {
    const fetchRutas = async () => {
      const localId = Storage.get('gravity_user_id');
      if (!localId) return;

      // ⚡ CARGA DESDE CACHÉ INICIAL (SOMBRA DE DATOS)
      const cached = Storage.get('gravity_cache_rutas_unificadas');
      if (cached) {
         try { setRutasGuardadas(JSON.parse(cached)); } catch(e){}
      }

      setCargandoRutas(true);
      try {
        // 🔍 BÚSQUEDA HÍBRIDA 
        // 1. Mis Rutas (Donde soy Fundador)
        const { data: rutasPropias } = await supabase.from('rutas').select('*').eq('creador_id', localId);
        
        // 2. Rutas del Club / Invitaciones (Donde soy Tripulante)
        const { data: misAsistencias } = await supabase.from('asistentes_rutas').select('ruta_id').eq('motero_id', localId);
        const idsAsistidos = misAsistencias?.map(a => a.ruta_id) || [];
        
        // Traemos el detalle de esas rutas, excluyendo las propias para evitar duplicidad
        const { data: rutasInvitado } = await supabase.from('rutas').select('*').in('id', idsAsistidos).neq('creador_id', localId);

        // 🧩 UNIFICACIÓN Y MAPPING
        const todas = [
          ...(rutasPropias || []).map(r => ({ ...r, rol: 'CREADOR' })),
          ...(rutasInvitado || []).map(r => ({ ...r, rol: 'INVITADO' }))
        ];

        const mapped = todas.map(r => ({
             id: r.id,
             nombre: r.nombre,
             puntoEncuentro: r.punto_encuentro,
             ciudad: r.ciudad,
             destino: r.destino,
             fecha: r.fecha,
             hora: r.hora,
             sena: r.sena,
             cilindraje: r.cilindraje_requerido || 'todos',
             privacidad: r.privacidad || 'publica',
             creador_id: r.creador_id,
             rol: r.rol
        }));
        
        setRutasGuardadas(mapped);
        Storage.set('gravity_cache_rutas_unificadas', JSON.stringify(mapped));
      } catch (e) {
        console.error("Error sincronizando rutas:", e);
      } finally {
        setCargandoRutas(false);
      }
    };
    fetchRutas();
  }, []);

  
  // Hook Secundario: Escuchar directivas globales (Teletransportación desde App.tsx)
  React.useEffect(() => {
    const handler = (e: any) => {
      if (e.detail) {
         verRuta(e.detail);
      }
    };
    window.addEventListener('abrirFichaRutaUrl', handler);
    return () => window.removeEventListener('abrirFichaRutaUrl', handler);
  }, []);

  const copiarCodigo = () => {
    navigator.clipboard.writeText(codigoReferido);
    setCodigoCopiado(true);
    setTimeout(() => setCodigoCopiado(false), 2000);
  };

  
  
  const eliminarRuta = (id: string) => {
    setDialogoConfirmacion({
      mensaje: '¿Seguro que deseas destruir esta ruta planificada y borrarla del mapa?',
      accion: async () => {
        // 1. Erradicar tripulantes confirmados (Limpieza de Huérfanos)
        await supabase.from('asistentes_rutas').delete().eq('ruta_id', id);

        // 2. Borrar central
        await supabase.from('rutas').delete().eq('id', id);
        
        // 3. Erradicar Fantasma en la Bóveda del Escuadrón (Si aplicó)
        const localId = Storage.get('gravity_user_id');
        if (localId) {
           const { data: esc } = await supabase.from('escuadrones').select('*').eq('capitan_id', localId).maybeSingle();
           if (esc && esc.rutas_club) {
               let arrayRutas = typeof esc.rutas_club === 'string' ? JSON.parse(esc.rutas_club) : esc.rutas_club;
               const rutasActualizadas = arrayRutas.filter((r:any) => r.id !== id);
               // Si se filtró una coincidencia, actualizamos
               if (rutasActualizadas.length !== arrayRutas.length) {
                   await supabase.from('escuadrones').update({ rutas_club: rutasActualizadas }).eq('id', esc.id);
               }
           }
        }

        setRutasGuardadas(prev => prev.filter(r => r.id !== id));
        setModoRuta('lista');
        setDialogoConfirmacion(null);
      }
    });
  };

  const [mostrarUpsellRutas, setMostrarUpsellRutas] = useState(false);

  const abrirFormularioCrear = async () => {
    let isOro = false;
    try {
      const myId = Storage.get('gravity_user_id');
      if (myId) {
        const { data } = await supabase.from('usuarios').select('es_oro').eq('id', myId).single();
        if (data) {
           isOro = !!data.es_oro;
           // Sincronizar local cache para que todo fluya
           const uStr = Storage.get('gravity_user');
           if (uStr) {
             const p = JSON.parse(uStr);
             p.es_oro = data.es_oro;
             Storage.set('gravity_user', JSON.stringify(p));
           }
        }
      }
    } catch(e) {}

    // 🛡️ FILTRO DE LIBERTAD: Solo contamos las rutas que el usuario HA CREADO.
    // Las invitaciones de otros no quitan el cupo de "Gratis".
    const misRutasPropias = rutasGuardadas.filter(r => r.rol === 'CREADOR');
    
    if (!isOro && misRutasPropias.length >= 1) {
      setMostrarUpsellRutas(true);
      return;
    }

    setRutaForm({ nombre: '', puntoEncuentro: '', ciudad: '', sena: '', destino: '', fecha: '', hora: '', privacidad: 'publica', cilindraje: 'todos' });
    setRutaIdEdicion(null);
    setModoRuta('crear');
  };

  const prepararEdicion = (ruta: any) => {
    setRutaIdEdicion(ruta.id);
    setRutaForm({
      nombre: ruta.nombre,
      puntoEncuentro: ruta.puntoEncuentro,
      ciudad: ruta.ciudad,
      sena: ruta.sena,
      destino: ruta.destino,
      fecha: ruta.fecha,
      hora: ruta.hora,
      privacidad: ruta.privacidad,
      cilindraje: ruta.cilindraje
    });
    setModoRuta('editar');
  };

  const handleGuardarRuta = async () => {
    if (!rutaForm.nombre || !rutaForm.puntoEncuentro || !rutaForm.destino || !rutaForm.ciudad) {
      alert("Completa el nombre, punto de encuentro, ciudad y destino al menos.");
      return;
    }
    
    const localId = Storage.get('gravity_user_id');
    if (!localId) {
       alert("Ingresa a tu perfil, llena completos tus datos guarda perfil y crea tu clave de ingreso.");
       return;
    }

    setGuardandoRuta(true);

    // Retrieve PIN from user profile in local storage
    let pin = '';
    try {
      const userStr = Storage.get('gravity_user');
      if (userStr) {
        const parsed = JSON.parse(userStr);
        pin = parsed.pin || '';
      }
    } catch (e) {
      console.warn("No se pudo parsear el PIN de gravity_user:", e);
    }

    if (!pin) {
       alert("Tu sesión de seguridad no tiene un PIN de acceso activo. Por favor, cierra sesión en tu perfil (menú lateral) y vuelve a ingresar para reactivarlo.");
       setGuardandoRuta(false);
       return;
    }

    if (rutaIdEdicion) {
      // --- EDITAR RUTA ---
      let editSuccess = false;
      let editError: any = null;

      try {
        // Modo A: Intento con RPC de seguridad
        const { data: rpcData, error: rpcError } = await supabase.rpc('editar_ruta_segura', {
          p_ruta_id: rutaIdEdicion,
          p_creador_id: localId,
          p_pin: pin,
          p_nombre: rutaForm.nombre,
          p_punto_encuentro: rutaForm.puntoEncuentro,
          p_ciudad: rutaForm.ciudad,
          p_destino: rutaForm.destino,
          p_fecha: rutaForm.fecha,
          p_hora: rutaForm.hora,
          p_sena: rutaForm.sena,
          p_cilindraje: rutaForm.cilindraje
        });

        if (rpcError) {
          // Si no existe la función, intentamos directo por PostgREST como plan de respaldo (Modo B)
          if (rpcError.code === 'PGRST202' || rpcError.code === 'PGRST501' || rpcError.code === '42883') {
            console.log("RPC 'editar_ruta_segura' no existe. Usando actualización directa...");
            const { error: directError } = await supabase.from('rutas').update({
              nombre: rutaForm.nombre,
              punto_encuentro: rutaForm.puntoEncuentro,
              ciudad: rutaForm.ciudad,
              destino: rutaForm.destino,
              fecha: rutaForm.fecha,
              hora: rutaForm.hora,
              sena: rutaForm.sena,
              cilindraje_requerido: rutaForm.cilindraje
            }).eq('id', rutaIdEdicion);

            if (directError) {
              editError = directError;
            } else {
              editSuccess = true;
            }
          } else {
            editError = rpcError;
          }
        } else {
          editSuccess = true;
        }
      } catch (err: any) {
        editError = err;
      }

      if (editSuccess) {
        setRutasGuardadas(prev => prev.map(r => r.id === rutaIdEdicion ? { ...rutaForm, id: r.id, rol: 'CREADOR', creador_id: localId } : r));
        setRutaSeleccionada({ ...rutaForm, id: rutaIdEdicion, rol: 'CREADOR', creador_id: localId });
        setModoRuta('ver');
      } else {
        console.error("Error al actualizar la ruta:", editError);
        alert(`Atención Gravity Bike: No se pudo actualizar la ruta.\n\nCódigo de Error: ${editError?.code || 'Desconocido'}\nDetalle: ${editError?.message || JSON.stringify(editError)}\n\nSi es un error de seguridad de base de datos (RLS / 42501), por favor ejecuta el script de habilitación de directivas en tu consola de administración de Supabase.`);
      }
      
    } else {
      // --- CREAR NUEVA RUTA ---
      let data: any = null;
      let saveError: any = null;

      try {
        // Modo A: Intento de creación segura por RPC de base de datos
        const { data: rpcData, error: rpcError } = await supabase.rpc('crear_ruta_segura', {
          p_creador_id: localId,
          p_pin: pin,
          p_nombre: rutaForm.nombre,
          p_punto_encuentro: rutaForm.puntoEncuentro,
          p_ciudad: rutaForm.ciudad,
          p_destino: rutaForm.destino,
          p_fecha: rutaForm.fecha,
          p_hora: rutaForm.hora,
          p_sena: rutaForm.sena,
          p_cilindraje: rutaForm.cilindraje
        });

        if (rpcError) {
          // Si no existe el RPC, intentamos la inserción directa por API de Supabase (Modo B)
          if (rpcError.code === 'PGRST202' || rpcError.code === 'PGRST501' || rpcError.code === '42883') {
            console.log("RPC 'crear_ruta_segura' no existe. Usando inserción directa...");
            const { data: directData, error: directError } = await supabase.from('rutas').insert([{
              creador_id: localId,
              nombre: rutaForm.nombre,
              punto_encuentro: rutaForm.puntoEncuentro,
              ciudad: rutaForm.ciudad,
              destino: rutaForm.destino,
              fecha: rutaForm.fecha,
              hora: rutaForm.hora,
              sena: rutaForm.sena,
              cilindraje_requerido: rutaForm.cilindraje
            }]).select().single();

            if (directError) {
              saveError = directError;
            } else {
              data = directData;
            }
          } else {
            saveError = rpcError;
          }
        } else {
          // El RPC devuelve el UUID de la fila creada
          data = { id: rpcData };
        }
      } catch (err: any) {
        saveError = err;
      }

      if (data) {
         setRutasGuardadas(prev => [{ ...rutaForm, id: data.id, rol: 'CREADOR', creador_id: localId }, ...prev]);
         setRutaSeleccionada({ ...rutaForm, id: data.id, rol: 'CREADOR', creador_id: localId });
         setModoRuta('ver');
      } else {
         console.error("Error al guardar la ruta:", saveError);
         alert(`Atención Gravity Bike: No se pudo guardar tu nueva ruta.\n\nCódigo de Error: ${saveError?.code || 'Desconocido'}\nDetalle: ${saveError?.message || JSON.stringify(saveError)}\n\nSi es un error de políticas RLS (42501), debes habilitar las directivas de inserción para usuarios 'anon' en la tabla 'rutas' desde tu consola de Supabase.`);
         setModoRuta('lista');
      }
    }

    setGuardandoRuta(false);
  };

  const compartirRuta = (ruta: any) => {
    let horaFormateada = 'Por definir';
    if (ruta.hora) {
      const [hours, minutes] = ruta.hora.split(':');
      let h = parseInt(hours, 10);
      const ampm = h >= 12 ? 'P.M.' : 'A.M.';
      h = h % 12;
      h = h ? h : 12; // el 0 debe ser 12
      horaFormateada = `${h}:${minutes} ${ampm}`;
    }

    // Generación matemática de emojis en memoria (100% inmune a codificación de disco)
    const iconBandera = String.fromCodePoint(0x1F3C1);
    const iconPin = String.fromCodePoint(0x1F4CD);
    const iconLupa = String.fromCodePoint(0x1F50D);
    const iconCalendario = String.fromCodePoint(0x1F4C5);
    const iconReloj = String.fromCodePoint(0x23F0);
    const iconMano = String.fromCodePoint(0x1F449);
    const iconBici = String.fromCodePoint(0x1F6B2);
    const iconCelular = String.fromCodePoint(0x1F4F2);

    const texto = `${iconBandera} *¡Vámonos de Rodada!: ${ruta.nombre}*

${iconPin} *Punto de Encuentro:* ${ruta.puntoEncuentro}, ${ruta.ciudad}
${iconLupa} *Señas:* ${ruta.sena || 'Ninguna'}
${iconBandera} *Destino:* ${ruta.destino}
${iconCalendario} *Fecha:* ${ruta.fecha || 'Por definir'}
${iconReloj} *Hora:* ${horaFormateada}

${iconMano} *CONFIRMA TU ASISTENCIA AQUÍ:*
https://pikishub.com/gravitybike/?unirse=${ruta.id}

Únete a esta ruta en ${iconBici} *GRAVITY BIKE* y usa mi código para tu perfil: *${codigoReferido}*

${iconCelular} *Descarga la App aquí:*
*https://pikishub.com/gravitybike/*`;
    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
  };

  const compartirAlClub = async (ruta: any) => {
     const localId = Storage.get('gravity_user_id');
     if (!localId) return;
     
     // Obtener el escuadrón activo del usuario desde sus membresías (Resiliente a duplicados)
     const { data: miembros } = await supabase.from('miembros_escuadron').select('escuadron_id').eq('motero_id', localId).limit(1);
     const miembroData = miembros && miembros.length > 0 ? miembros[0] : null;
     
     let esc = null;
     if (miembroData) {
        const { data: escData } = await supabase.from('escuadrones').select('*').eq('id', miembroData.escuadron_id).maybeSingle();
        if (escData && escData.capitan_id === localId) {
           esc = escData;
        }
     }
     
     if (!esc) {
        setDialogoConfirmacion({
           titulo: '¡SÉ UN LÍDER DE ESCUADRÓN!',
           mensaje: 'Para convocar rutas oficiales y compartirlas en el cuartel, primero debes fundar tu propio Club en la Mesa Redonda. ¡Lidera el camino!',
           color: 'emerald',
           botonTexto: 'ENTENDIDO LÍDER',
           accion: () => setDialogoConfirmacion(null)
        });

        return;
     }
     
     let rutasClubVal = [];
     if (esc.rutas_club) {
         rutasClubVal = typeof esc.rutas_club === 'string' ? JSON.parse(esc.rutas_club) : esc.rutas_club;
     }
     
     if (!rutasClubVal.some((r:any) => r.id === ruta.id)) {
        rutasClubVal.push(ruta);
        // Supabase update
        await supabase.from('escuadrones').update({ rutas_club: rutasClubVal }).eq('id', esc.id);
     }
     
     const userStr = Storage.get('gravity_user');
     let miNombre = "El Líder";
     try { if (userStr) miNombre = JSON.parse(userStr).nombre?.split(' ')[0] || "El Líder"; } catch(e){}
     
     const msgObj = {
        escuadron_id: esc.id,
        emisor_id: localId,
        emisor_nombre: miNombre,
        mensaje: `🏍️ NUEVA RUTA OFICIAL CONVOCADA: ${ruta.nombre}\nEncuentro: ${ruta.puntoEncuentro}\nDestino: ${ruta.destino}\nRevisa la Bóveda de Rutas Oficiales para confirmar asistencia.`
     };
     await supabase.from('chat_escuadrones').insert([msgObj]);
     
     setDialogoConfirmacion({
        titulo: '¡EXCELENTE LIDER!',
        mensaje: 'Rodada oficialmente compartida con el Club. Tus colegas ya pueden verla en su Bóveda de Misiones.',
        color: 'emerald',
        botonTexto: 'LISTO',
        accion: () => setDialogoConfirmacion(null)
     });

  };

  
  const verRuta = async (ruta: any) => {
    setRutaSeleccionada(ruta);
    setModoRuta('ver');
    
    // Cargar pasajeros instantáneamente de la DB
    setAsistentesRuta([]);
    const { data: rawAsistentes } = await supabase.from('asistentes_rutas').select('*').eq('ruta_id', ruta.id);
    
    if (rawAsistentes && rawAsistentes.length > 0) {
      // Intentar traer los avatars en una segunda consulta segura
      const idsMoteros = rawAsistentes.map(a => a.motero_id).filter(id => !!id);
      const { data: dataAvatars } = await supabase.from('usuarios').select('id, avatar_url').in('id', idsMoteros);
      
      const asistentesConAvatar = rawAsistentes.map(asistente => {
        const userAvatar = dataAvatars?.find(u => u.id === asistente.motero_id);
        return {
          ...asistente,
          avatar_url_perfil: userAvatar?.avatar_url
        };
      });
      setAsistentesRuta(asistentesConAvatar);
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col h-full relative bg-transparent"
    >
      {/* BANNER DE DISEÑO: PLANIFICADOR GLOBAL */}
      <div className="relative w-full h-32 rounded-3xl overflow-hidden mb-2 shrink-0 shadow-[0_10px_30px_rgba(0,168,255,0.15)] group mx-auto border border-blue-500/20">
        <img 
          src={routeBanner} 
          className="absolute inset-0 w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-700" 
          alt="Ruta Banner" 
        />
      </div>

      {/* TEXTO DEL TITULO DEBAJO DE LA IMAGEN */}
      <div className="flex flex-col items-center text-center mb-4 shrink-0">
        <div className="flex items-center gap-2 mb-1.5">
           <span className="bg-primary-cyan/20 border border-primary-cyan text-primary-cyan text-[8px] font-black uppercase tracking-widest px-2.5 py-0.5 rounded-full inline-block">Mundo Diferente</span>
           {cargandoRutas && <RefreshCw className="w-3 h-3 text-primary-cyan animate-spin" />}
        </div>
        <h2 className="text-white font-black text-xl tracking-tighter leading-none drop-shadow-[0_0_15px_rgba(0,168,255,0.3)] uppercase">PLANIFICADOR DE RUTAS</h2>
      </div>

      <button 
        onClick={abrirFormularioCrear}
        className="w-fit mx-auto bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-500 hover:to-cyan-400 border border-blue-400/30 text-white py-2.5 px-6 rounded-full text-[10px] font-black uppercase tracking-widest flex items-center justify-center gap-2 active:scale-95 transition-all shadow-[0_0_20px_rgba(59,130,246,0.4)] mb-5 shrink-0"
      >
        <Edit3 className="w-4 h-4 text-white" /> Trazar Nueva Ruta
      </button>

      {/* CONTENIDO CONTENEDOR LISTA */}
      <div className="flex-1 overflow-y-auto pb-6 scrollbar-hide">
        {rutasGuardadas.length === 0 ? (
          <div className="text-center py-10 bg-slate-800/20 rounded-2xl border border-dashed border-white/10">
            <Navigation className="w-10 h-10 text-slate-600 mx-auto mb-3" />
            <p className="text-slate-400 font-medium text-[13px]">Aún no has planeado ninguna ruta.</p>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {[...rutasGuardadas].sort((a, b) => {
              if (!a.fecha) return 1;
              if (!b.fecha) return -1;
              const dateA = new Date(`${a.fecha}T${a.hora || '00:00'}`).getTime();
              const dateB = new Date(`${b.fecha}T${b.hora || '00:00'}`).getTime();
              return dateA - dateB;
            }).map((ruta) => {
              const uStr = Storage.get('gravity_user');
              const isOro = uStr ? !!JSON.parse(uStr).es_oro : false;

              // 🛡️ NUEVA LÓGICA DE BLOQUEO SELECTIVO:
              // Solo se cuenta el límite para rutas de las que somos CREADOR.
              // Las rutas de INVITADO siempre están abiertas para todos.
              const misPropias = rutasGuardadas.filter(r => r.rol === 'CREADOR');
              const miIndicePropio = misPropias.findIndex(r => r.id === ruta.id);
              
              const esPropia = ruta.rol === 'CREADOR';
              const estaBloqueada = !isOro && esPropia && miIndicePropio >= 1;
             
              return (
              <div 
                key={ruta.id} 
                className={`bg-gradient-to-r from-[#1e293b] to-[#0f172a] border ${ruta.rol === 'CREADOR' ? 'border-primary-cyan/30 shadow-[0_0_15px_rgba(0,168,255,0.1)]' : 'border-emerald-500/30 shadow-[0_0_15px_rgba(16,185,129,0.1)]'} rounded-2xl pt-6 pb-2 px-4 flex items-center justify-between relative overflow-hidden ${estaBloqueada ? 'opacity-90' : ''}`}
              >
                {/* ETIQUETA DE ROL: DISEÑO DE PESTAÑA CENTRADA (Buscando Simetría) */}
                <div className={`absolute top-0 left-1/2 -translate-x-1/2 px-4 py-0.5 rounded-b-xl text-[7px] font-black uppercase tracking-[0.2em] shadow-lg ${ruta.rol === 'CREADOR' ? 'bg-primary-cyan text-bg-dark shadow-primary-cyan/20' : 'bg-emerald-500 text-bg-dark shadow-emerald-500/20'}`}>
                   {ruta.rol || 'INVITADO'}
                </div>

                {estaBloqueada && (
                  <div className="absolute inset-0 bg-black/80 backdrop-blur-sm z-20 flex items-center justify-center cursor-pointer border border-yellow-500/30 rounded-2xl" onClick={() => setMostrarUpsellRutas(true)}>
                     <Crown className="w-5 h-5 text-yellow-500 mr-2 drop-shadow-[0_0_10px_rgba(234,179,8,0.5)]" />
                     <span className="text-yellow-500 font-black text-[12px] uppercase tracking-widest text-center shadow-black drop-shadow-md">🔒 Ruta Bloqueada<br/><span className="text-[9px] text-yellow-200">Exclusivo Plan SCORE ORO</span></span>
                  </div>
                )}
                <div className={estaBloqueada ? 'blur-[2px]' : ''}>
                  <h3 className="text-white font-black text-xs uppercase mb-1 leading-tight max-w-[200px] truncate pr-2">{ruta.nombre}</h3>
                  <p className="text-slate-400 text-[10px] font-bold flex items-center gap-1">
                    <Calendar className="w-3 h-3 text-primary-cyan" /> {ruta.fecha || 'Sin fecha'} {ruta.hora && `- ${ruta.hora}`}
                  </p>
                </div>
                <button 
                  onClick={() => !estaBloqueada && verRuta(ruta)}
                  disabled={estaBloqueada}
                  className={`${ruta.rol === 'CREADOR' ? 'bg-primary-cyan/10 text-primary-cyan border-primary-cyan/20 hover:bg-primary-cyan shadow-[0_0_10px_rgba(0,168,255,0.1)]' : 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20 hover:bg-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.1)]'} border px-4 py-2 rounded-xl text-[11px] font-black uppercase tracking-wider hover:text-bg-dark transition-all flex items-center gap-1.5 shrink-0 cursor-pointer ${estaBloqueada ? 'opacity-0 pointer-events-none' : ''}`}
                >
                  <MapPin className="w-3.5 h-3.5" /> Ver
                </button>
              </div>
            )})}
          </div>
        )}
      </div>

      {/* OVERLAY UNIVERSAL: VER, CREAR, EDITAR */}
      <AnimatePresence>
        {(modoRuta === 'ver' || modoRuta === 'crear' || modoRuta === 'editar') && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-md flex flex-col items-center justify-start pt-10 pb-10 px-4 overflow-x-hidden overflow-y-auto"
          >
            <div className="bg-gradient-to-br from-[#1e293b] to-[#0f172a] border border-white/10 rounded-3xl overflow-hidden shadow-[0_10px_50px_rgba(0,0,0,0.8)] relative w-full max-w-sm shrink-0">
              
              {/* FONDO FANTASMA SUBLIMINAL DE AVENTURA */}
              {modoRuta === 'ver' && (
                 <div 
                   className="absolute inset-0 bg-cover bg-center mix-blend-screen opacity-[0.06] pointer-events-none z-0"
                   style={{ backgroundImage: `url('https://images.unsplash.com/photo-1590403370390-3cb83ed3dbb8?auto=format&fit=crop&q=80&w=800')` }}
                 ></div>
              )}

              <button 
                onClick={() => setModoRuta('lista')} 
                className="absolute top-4 right-4 bg-black/50 backdrop-blur-md p-2 rounded-full text-white hover:bg-black/80 z-50 transition-colors border border-white/20"
              >
                 <X className="w-6 h-6" />
              </button>

              {modoRuta === 'ver' && rutaSeleccionada && (
                <>
                  {/* Header Fotográfico Ver */}
                  <div className="h-[160px] bg-slate-800 relative flex flex-col justify-end p-5 shrink-0">
                    <img 
                      src={routeDetailRecord} 
                      className="absolute inset-0 w-full h-full object-cover object-center mix-blend-overlay opacity-25 pointer-events-none" 
                      alt="Ruta Detail Banner"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] via-[#0f172a]/60 to-transparent"></div>
                    
                    <div className="absolute top-4 left-4 flex gap-2 z-10">
                      <div className={`px-2.5 py-1 rounded-md text-[10px] font-black uppercase backdrop-blur-md border shadow-lg ${rutaSeleccionada.privacidad === 'publica' ? 'bg-green-500/40 text-green-100 border-green-500/50' : 'bg-red-500/40 text-red-100 border-red-500/50'}`}>
                        {rutaSeleccionada.privacidad === 'publica' ? 'Pública' : 'Privada'}
                      </div>
                    </div>

                    <h3 className="text-white font-black text-2xl z-10 drop-shadow-md uppercase leading-none">{rutaSeleccionada.nombre}</h3>
                    <p className="text-slate-200 text-[11px] font-bold z-10 drop-shadow flex items-center gap-1 mt-1.5">
                      <Calendar className="w-3.5 h-3.5 text-primary-cyan" /> {rutaSeleccionada.fecha || 'Sin fecha'} {rutaSeleccionada.hora && `- ${rutaSeleccionada.hora}`}
                    </p>
                  </div>

                  <div className="p-5 relative z-10">
                    {/* Detalles del Encuentro */}
                    <div className="bg-black/30 p-4 rounded-2xl border border-white/5 mb-5 shadow-inner">
                      <h4 className="text-[10px] text-primary-cyan font-black uppercase tracking-wider mb-2 flex items-center gap-1">
                        <MapPin className="w-3.5 h-3.5" /> Punto de Encuentro
                      </h4>
                      <p className="text-white text-[15px] font-bold leading-tight">{rutaSeleccionada.puntoEncuentro}</p>
                      <p className="text-slate-400 text-[12px] font-medium leading-tight mt-1">{rutaSeleccionada.ciudad} {rutaSeleccionada.sena && `(${rutaSeleccionada.sena})`}</p>
                    </div>

                    <div className="flex items-center gap-3 mb-6 px-1">
                      <div className="flex flex-col items-center">
                        <MapPin className="w-5 h-5 text-green-500 mb-1" />
                      </div>
                      <div className="flex-1 border-b-2 border-dashed border-white/10 relative"></div>
                      <div className="text-center bg-[#0f172a] text-[10px] text-white font-black uppercase truncate px-3 py-1.5 rounded-full border border-white/10 shadow-md">
                         DESTINO FINAL
                      </div>
                      <div className="flex-1 border-b-2 border-dashed border-white/10 relative"></div>
                      <div className="flex flex-col items-center">
                        <Navigation className="w-5 h-5 text-red-500 mb-1" />
                      </div>
                    </div>
                    <p className="text-center text-[17px] font-black text-white px-2 uppercase mb-4 shadow-sm">{rutaSeleccionada.destino}</p>

                    {/* CONTADOR EN VIVO DE INVITADOS */}
                    <div className="mb-4">
                      <button 
                        onClick={() => setMostrarAsistentes(true)}
                        className="w-full bg-slate-800/80 hover:bg-slate-700 transition-colors border border-white/10 py-3.5 rounded-2xl flex items-center justify-center gap-3 shadow-inner"
                      >
                         <Users className="w-5 h-5 text-primary-cyan flex-shrink-0" />
                         <span className="text-white font-black uppercase text-[13px] tracking-widest">{asistentesRuta.length} Piloto{asistentesRuta.length === 1 ? '' : 's'} Confirmado{asistentesRuta.length === 1 ? '' : 's'}</span>
                      </button>
                    </div>

                    {/* BOTONES NATIVOS DE NAVEGACIÓN */}
                    <div className="mb-6 flex flex-col gap-3">
                      <a 
                        href={`https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(rutaSeleccionada.puntoEncuentro + ', ' + rutaSeleccionada.ciudad + ', Colombia')}&destination=${encodeURIComponent(rutaSeleccionada.destino + ', Colombia')}&travelmode=driving`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full bg-gradient-to-br from-green-500/20 to-emerald-600/30 border border-green-500/50 hover:bg-green-500 hover:text-white transition-all text-green-400 font-black py-2.5 rounded-2xl shadow-[0_4px_20px_rgba(34,197,94,0.3)] flex flex-col items-center justify-center gap-1"
                      >
                         <span className="flex items-center gap-2 text-[15px] uppercase tracking-wider"><Navigation className="w-5 h-5" /> Abrir Google Maps</span>
                         <span className="text-[9px] font-bold uppercase tracking-widest opacity-80">Rastreo de Peajes & Vías</span>
                      </a>

                      <a 
                        href={`https://waze.com/ul?q=${encodeURIComponent(rutaSeleccionada.destino + ', Colombia')}&navigate=yes`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full bg-gradient-to-br from-blue-500/20 to-cyan-600/30 border border-blue-500/50 hover:bg-blue-500 hover:text-white transition-all text-blue-400 font-black py-2.5 rounded-2xl shadow-[0_4px_20px_rgba(59,130,246,0.3)] flex flex-col items-center justify-center gap-1"
                      >
                         <span className="flex items-center gap-2 text-[15px] uppercase tracking-wider"><svg className="w-5 h-5 fill-current" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12c0 2.21.72 4.25 1.93 5.89L2.61 21.4c-.13.38.11.77.49.8.84.06 2.65-.05 4.31-.63A9.95 9.95 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm1.68 14.88c-1.16 0-2.31-.22-3.37-.62-.16-.06-.33.02-.38.16l-.28.84c-.06.16.02.32.18.38 1.2.44 2.5.68 3.85.68 5.76 0 10.44-4.66 10.44-10.37S19.46 3.6 13.7 3.6C7.94 3.6 3.26 8.27 3.26 13.98c0 .32.02.63.05.94H6.3c.75.12 1.48.24 2.19.44.18.05.28.24.22.42l-.28.84c-.05.18-.24.28-.42.22-.84-.24-1.7-.38-2.6-.52-.36 1.83-1.8 3.08-3.08 3.52 1.24.47 2.6.72 4.05.72 5.06 0 9.17-4.1 9.17-9.17s-4.11-9.17-9.17-9.17S2.5 8.91 2.5 13.98c0 1.25.26 2.45.73 3.55 1.18-.5 2.54-1.64 2.87-3.32h-3c-.02-.3-.04-.61-.04-.92C3.06 8.16 7.84 3.32 13.7 3.32S24.34 8.16 24.34 14.07 19.56 24.81 13.7 24.81zM10.1 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7.9 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6.04 6.8c-.85 0-1.55.62-1.67 1.44h8.34c-.12-.82-.82-1.44-1.67-1.44h-5z"/></svg> Abrir con Waze</span>
                         <span className="text-[9px] font-bold uppercase tracking-widest opacity-80">Rastreo de Cámaras & Retenes</span>
                      </a>
                    </div>

                    {/* BOTONES ADMINISTRATIVOS Y DE ACCIÓN: EXCLUSIVOS PARA EL CREADOR */}
                    {rutaSeleccionada.creador_id === Storage.get('gravity_user_id') && (
                      <>
                        <div className="flex gap-2">
                          <button 
                            onClick={() => {
                              eliminarRuta(rutaSeleccionada.id);
                              setModoRuta('lista');
                            }}
                            className="py-3 px-4 bg-red-500/10 text-red-500 hover:bg-red-500/20 transition-colors rounded-xl font-bold border border-red-500/20 flex items-center justify-center shrink-0"
                          >
                            <Trash2 className="w-5 h-5" />
                          </button>
                          
                          <button 
                            onClick={() => prepararEdicion(rutaSeleccionada)}
                            className="flex-1 py-3 bg-slate-800 text-white hover:bg-slate-700 transition-colors rounded-xl font-bold text-[12px] uppercase tracking-wider border border-white/10 flex items-center justify-center gap-1.5"
                          >
                            <Edit3 className="w-4 h-4" /> Editar
                          </button>

                          <button 
                            onClick={() => compartirRuta(rutaSeleccionada)}
                            className="flex-1 py-3 bg-gradient-to-r from-blue-600 to-primary-cyan text-white hover:from-blue-500 hover:to-cyan-400 transition-colors rounded-xl font-bold text-[12px] uppercase tracking-wider shadow-[0_4px_15px_rgba(0,168,255,0.3)] flex items-center justify-center gap-1.5"
                          >
                            <Share2 className="w-4 h-4" /> Invitar
                          </button>
                        </div>

                        <button 
                          onClick={() => compartirAlClub(rutaSeleccionada)} 
                          className="mt-3 w-full py-3 bg-indigo-900 border border-indigo-500/50 hover:bg-indigo-800 transition-colors text-white rounded-xl font-bold text-[12px] uppercase tracking-wider flex items-center justify-center gap-1.5 shadow-[0_4px_15px_rgba(79,70,229,0.2)]"
                        >
                          <Shield className="w-4 h-4 text-indigo-400" /> Compartir al Club (Mesa ReDonda)
                        </button>
                      </>
                    )}
                  </div>
                </>
              )}

              {(modoRuta === 'crear' || modoRuta === 'editar') && (
                <div className="p-5 overflow-y-auto">
                  <h3 className="text-white font-black text-lg mb-5 flex items-center gap-2 border-b border-white/10 pb-3">
                    <Edit3 className="w-5 h-5 text-primary-cyan" /> 
                    {modoRuta === 'crear' ? 'Nueva Ruta' : 'Editando Ruta'}
                  </h3>

                  <div className="flex flex-col gap-2">
                    <div className="bg-slate-800/40 border border-white/5 rounded-2xl px-3 py-2">
                      <label className="text-[11px] text-slate-400 font-bold uppercase tracking-wide mb-1 block">Nombre de la Rodada</label>
                      <input 
                        type="text" 
                        value={rutaForm.nombre}
                        onChange={e => setRutaForm({...rutaForm, nombre: e.target.value.toUpperCase()})}
                        placeholder="Ej: VUELTA A LA LAGUNA"
                        className="w-full bg-black/50 border border-white/10 text-white text-[15px] font-bold rounded-xl py-2 px-3 outline-none focus:border-primary-cyan transition-colors uppercase placeholder:normal-case"
                      />
                    </div>

                    <div className="bg-slate-800/40 border border-white/5 rounded-2xl px-3 py-2">
                      <h4 className="text-[12px] font-bold text-white mb-1.5 text-primary-cyan uppercase tracking-wider">Ubica tu Parche</h4>
                      
                      <div className="flex flex-col gap-1.5">
                        <div className="flex items-center gap-2 bg-black/50 border border-white/10 rounded-xl px-3 py-2">
                           <MapPin className="w-4 h-4 text-green-500 shrink-0" />
                           <input 
                             type="text" 
                             value={rutaForm.puntoEncuentro}
                             onChange={e => setRutaForm({...rutaForm, puntoEncuentro: capitalizarPalabras(e.target.value)})}
                             placeholder="Lugar exacto (Ej. Bomba Terpel)"
                             className="bg-transparent border-none text-white text-[14px] font-bold w-full outline-none"
                           />
                        </div>
                        
                        <div className="flex items-center gap-2 bg-black/50 border border-white/10 rounded-xl px-3 py-2">
                           <Navigation className="w-4 h-4 text-slate-400 shrink-0" />
                           <input 
                             type="text" 
                             value={rutaForm.ciudad}
                             onChange={e => setRutaForm({...rutaForm, ciudad: capitalizarPalabras(e.target.value)})}
                             placeholder="Ciudad de partida"
                             className="bg-transparent border-none text-white text-[14px] font-bold w-full outline-none"
                           />
                        </div>

                        <div className="flex items-start gap-2 bg-black/50 border border-white/10 rounded-xl px-3 py-2">
                           <AlertTriangle className="w-4 h-4 text-yellow-500 shrink-0 mt-0.5" />
                           <textarea 
                             rows={2}
                             value={rutaForm.sena}
                             onChange={e => setRutaForm({...rutaForm, sena: capitalizarPalabras(e.target.value)})}
                             placeholder="Señas o indicaciones detalladas..."
                             className="bg-transparent border-none text-white text-[14px] font-bold w-full outline-none resize-none leading-tight"
                           />
                        </div>
                      </div>
                    </div>

                    <div className="bg-slate-800/40 border border-white/5 rounded-2xl px-3 py-2">
                      <label className="text-[11px] text-slate-400 font-bold uppercase tracking-wide mb-1 block">Destino Final de Llegada</label>
                      <div className="flex items-center gap-2 bg-black/50 border border-white/10 rounded-xl px-3 py-2">
                         <Navigation className="w-4 h-4 text-red-500 shrink-0" />
                         <input 
                           type="text" 
                           value={rutaForm.destino}
                           onChange={e => setRutaForm({...rutaForm, destino: capitalizarPalabras(e.target.value)})}
                           placeholder="Un pueblo viejo, Mirador..."
                           className="bg-transparent border-none text-white text-[14px] font-bold w-full outline-none"
                         />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <div className="bg-slate-800/40 border border-white/5 rounded-2xl px-3 py-2">
                        <label className="text-[11px] text-slate-400 font-bold uppercase tracking-wide mb-1 block">Fecha Planeada</label>
                        <div className="flex items-center gap-2 bg-black/50 border border-white/10 rounded-xl px-2.5 py-2">
                           <Calendar className="w-4 h-4 text-primary-cyan shrink-0" />
                           <input 
                             type="date" 
                             value={rutaForm.fecha}
                             onChange={e => setRutaForm({...rutaForm, fecha: e.target.value})}
                             className="bg-transparent border-none text-white text-[14px] font-bold w-full outline-none [&::-webkit-calendar-picker-indicator]:filter [&::-webkit-calendar-picker-indicator]:invert pr-0 mr-0"
                           />
                        </div>
                      </div>
                      <div className="bg-slate-800/40 border border-white/5 rounded-2xl px-3 py-2">
                        <label className="text-[11px] text-slate-400 font-bold uppercase tracking-wide mb-1 block">Hora Encuentro</label>
                        <div className="flex items-center gap-2 bg-black/50 border border-white/10 rounded-xl px-2.5 py-2">
                           <Clock className="w-4 h-4 text-yellow-500 shrink-0" />
                           <input 
                             type="time" 
                             value={rutaForm.hora}
                             onChange={e => setRutaForm({...rutaForm, hora: e.target.value})}
                             className="bg-transparent border-none text-white text-[14px] font-bold w-full outline-none [&::-webkit-calendar-picker-indicator]:filter [&::-webkit-calendar-picker-indicator]:invert pr-0 mr-0"
                           />
                        </div>
                      </div>
                    </div>

                    <div className="bg-slate-800/40 border border-white/5 rounded-2xl px-3 py-2">
                      <h4 className="text-[12px] font-bold text-white mb-1.5 text-primary-cyan uppercase tracking-wider">Opciones Avanzadas</h4>
                      <div className="mb-2">
                        <label className="text-[10px] text-slate-400 font-bold uppercase tracking-wide mb-1 block">Visibilidad de la Ruta</label>
                        <div className="flex gap-2 bg-black/50 p-1 rounded-xl border border-white/5">
                          <button 
                            onClick={() => setRutaForm({...rutaForm, privacidad: 'publica'})}
                            className={`flex-1 py-1.5 text-[12px] font-bold rounded-lg flex items-center justify-center gap-1.5 transition-all ${rutaForm.privacidad === 'publica' ? 'bg-green-500/20 text-green-400 border border-green-500/30 shadow-inner' : 'text-slate-500'}`}
                          >
                            <Users className="w-3.5 h-3.5" /> Pública
                          </button>
                          <button 
                            onClick={() => setRutaForm({...rutaForm, privacidad: 'privada'})}
                            className={`flex-1 py-1.5 text-[12px] font-bold rounded-lg flex items-center justify-center gap-1.5 transition-all ${rutaForm.privacidad === 'privada' ? 'bg-danger-red/20 text-danger-red border border-danger-red/30 shadow-inner' : 'text-slate-500'}`}
                          >
                            <Lock className="w-3.5 h-3.5" /> Privada
                          </button>
                        </div>
                      </div>


                    </div>

                    <button 
                      onClick={handleGuardarRuta}
                      disabled={guardandoRuta}
                      className={`mt-1 w-full py-4 text-bg-dark rounded-xl font-black uppercase tracking-widest text-[13px] transition-all ${guardandoRuta ? 'bg-slate-700 text-slate-400 cursor-not-allowed opacity-65' : 'bg-primary-cyan hover:bg-cyan-400 active:scale-95 shadow-[0_0_20px_rgba(0,168,255,0.4)]'}`}
                    >
                      {guardandoRuta ? (
                        <span className="flex items-center justify-center gap-2">
                          <RefreshCw className="w-4 h-4 animate-spin" /> Guardando...
                        </span>
                      ) : (
                        modoRuta === 'editar' ? 'Actualizar Ruta' : 'Guardar y Publicar Ruta'
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* OVERLAY DE CONFIRMACIÓN PROPIA */}
      <AnimatePresence>
        {dialogoConfirmacion && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[130] bg-black/80 backdrop-blur-md flex items-center justify-center p-6"
          >
            <motion.div 
              initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 20 }}
              className={`w-full max-w-xs bg-slate-900 border ${dialogoConfirmacion.color === 'emerald' ? 'border-emerald-500/30 shadow-[0_0_50px_rgba(16,185,129,0.2)]' : 'border-red-500/30 shadow-[0_0_50px_rgba(239,68,68,0.2)]'} rounded-3xl p-6 text-center`}
            >
              <div className={`w-16 h-16 ${dialogoConfirmacion.color === 'emerald' ? 'bg-emerald-500/10 border-emerald-500/20' : 'bg-red-500/10 border-red-500/20'} rounded-full flex items-center justify-center mx-auto mb-4 border shadow-inner`}>
                {dialogoConfirmacion.color === 'emerald' ? (
                   <CheckCircle className="w-8 h-8 text-emerald-500" />
                ) : (
                   <AlertTriangle className="w-8 h-8 text-red-500" />
                )}
              </div>
              <h3 className="text-white font-black text-lg mb-2 uppercase tracking-wide">{dialogoConfirmacion.titulo || '¿Estás Seguro?'}</h3>
              <p className="text-slate-400 text-[12px] font-medium leading-relaxed mb-6">{dialogoConfirmacion.mensaje}</p>
              
              {dialogoConfirmacion.color === 'emerald' ? (
                <button 
                  onClick={dialogoConfirmacion.accion}
                  className="w-full py-3 bg-emerald-500 text-bg-dark rounded-xl font-black text-[11px] uppercase tracking-wider shadow-[0_0_15px_rgba(16,185,129,0.4)] hover:bg-emerald-600 active:scale-95 transition-all"
                >
                  {dialogoConfirmacion.botonTexto || 'ACEPTAR'}
                </button>
              ) : (
                <div className="flex gap-3">
                  <button 
                    onClick={() => setDialogoConfirmacion(null)}
                    className="flex-1 py-3 rounded-xl border border-white/10 text-white font-bold text-[11px] uppercase tracking-wider hover:bg-white/5 transition-colors"
                  >
                    {dialogoConfirmacion.botonTexto ? 'Cerrar' : 'Cancelar'}
                  </button>
                  <button 
                    onClick={dialogoConfirmacion.accion}
                    className="flex-1 py-3 bg-red-500 text-white rounded-xl font-black text-[11px] uppercase tracking-wider shadow-[0_0_15px_rgba(239,68,68,0.4)] hover:bg-red-600 active:scale-95 transition-all"
                  >
                    {dialogoConfirmacion.botonTexto || 'Sí, Eliminar'}
                  </button>
                </div>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* MODAL BOTTOM-SHEET: LISTA DE ASISTENTES CONFIRMADOS */}
      <AnimatePresence>
        {mostrarAsistentes && (
          <motion.div 
            initial={{ opacity: 0, y: "100%" }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: "100%" }}
            transition={{ type: "spring", bounce: 0, duration: 0.4 }}
            className="fixed inset-0 z-[120] bg-black/80 backdrop-blur-sm flex flex-col justify-end overflow-hidden"
          >
            {/* Click afuera cierra */}
            <div className="absolute inset-0 z-0" onClick={() => setMostrarAsistentes(false)}></div>
            
            <div className="relative z-10 bg-[#0f172a] w-full max-w-md mx-auto h-[75vh] rounded-t-3xl border-t border-white/10 shadow-[0_-10px_50px_rgba(0,0,0,0.8)] flex flex-col pt-3 pb-8 px-5">
               <div className="w-14 h-1.5 bg-white/20 rounded-full mx-auto mb-6 shrink-0"></div>
               <div className="flex justify-between items-center mb-6 shrink-0 pb-4 border-b border-white/5">
                 <h2 className="text-white font-black uppercase text-[16px] tracking-wide flex items-center gap-2">
                    <Users className="w-5 h-5 text-primary-cyan" /> Moteros Confirmados
                 </h2>
                 <button onClick={() => setMostrarAsistentes(false)} className="bg-slate-800 p-2 rounded-full border border-white/10">
                    <X className="w-5 h-5 text-slate-400" />
                 </button>
               </div>
               
               <div className="overflow-y-auto w-full flex-1 space-y-3 pb-20">
                 {asistentesRuta.length === 0 ? (
                    <div className="text-center py-16 opacity-50 flex flex-col items-center">
                       <CheckCircle className="w-12 h-12 text-slate-500 mb-3 opacity-50"/>
                       <p className="text-[12px] font-black text-white uppercase tracking-widest">Nadie ha confirmado aún</p>
                       <p className="text-[10px] font-medium text-slate-400 mt-2 max-w-[200px]">Invita más pilotos usando el botón principal de Inivtar</p>
                    </div>
                 ) : (
                    asistentesRuta.map(asistente => (
                       <motion.div 
                         initial={{ opacity:0, scale:0.95 }} animate={{opacity:1, scale:1}}
                         key={asistente.id} 
                         className="bg-slate-800/40 border border-white/5 p-3.5 rounded-2xl flex items-center gap-4 bg-gradient-to-r from-transparent to-slate-800/20 shadow-sm"
                       >
                          <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center shrink-0 shadow-[0_0_15px_rgba(0,168,255,0.2)] border border-white/10 overflow-hidden relative">
                             {asistente.avatar_url_perfil ? (
                               <img 
                                 src={asistente.avatar_url_perfil} 
                                 alt={asistente.nombre} 
                                 className="w-full h-full object-cover"
                               />
                             ) : (
                               <div className="w-full h-full bg-gradient-to-br from-primary-cyan to-blue-600 flex items-center justify-center">
                                 <span className="text-white font-black text-lg">{asistente.nombre.charAt(0).toUpperCase()}</span>
                               </div>
                             )}
                          </div>
                          <div className="flex-1 min-w-0">
                             <h4 className="text-white font-black text-[14px] uppercase truncate leading-none">{asistente.nombre}</h4>
                             <p className="text-primary-cyan text-[10px] font-mono tracking-widest border border-primary-cyan/30 bg-primary-cyan/10 px-2.5 py-0.5 rounded shadow-inner inline-block mt-1.5">PLACA: {asistente.placa}</p>
                          </div>
                          <CheckCircle className="w-6 h-6 text-green-500 shadow-lg shrink-0" />
                       </motion.div>
                    ))
                 )}
               </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* UPSELL ORO - LIMITE RUTAS (max 2 gratis) */}
      <AnimatePresence>
        {mostrarUpsellRutas && (
          <motion.div 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-md flex flex-col items-center justify-center p-5"
          >
            <div className="w-full max-w-sm bg-gradient-to-b from-[#1e293b] to-[#0f172a] border border-yellow-500/30 rounded-3xl p-8 relative shadow-[0_0_50px_rgba(234,179,8,0.2)] text-center">
              <button 
                onClick={() => setMostrarUpsellRutas(false)} 
                className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
              
              <div className="w-20 h-20 mx-auto bg-gradient-to-br from-yellow-500/20 to-amber-600/30 border border-yellow-500/40 rounded-full flex flex-col items-center justify-center shadow-inner mb-6">
                 <Crown className="w-10 h-10 text-yellow-500 drop-shadow-[0_0_10px_rgba(234,179,8,0.6)]" />
              </div>
              
              <h2 className="text-white font-black text-xl tracking-wide uppercase mb-3 leading-tight">
                 Rutas Máximas <span className="text-primary-cyan block mt-1">Alcanzadas</span>
              </h2>
              
              <p className="text-slate-400 text-sm font-medium leading-relaxed mb-8 px-2">
                 Estás usando la versión gratuita y ya agendaste tu único destino gratuito permitido. 
                 <br/><br/>Para poder crear <strong className="text-yellow-500">Rutas Ilimitadas</strong> e invitar libremente a tu parche sin bloqueos, debes obtener el <strong className="text-gold-cert">Plan SCORE ORO</strong>.
              </p>
              
              <button 
                 onClick={() => {
                   setMostrarUpsellRutas(false);
                   document.dispatchEvent(new Event('abrirMembresiaOro'));
                 }}
                 className="w-full py-4 rounded-xl font-black text-[13px] uppercase tracking-widest transition-all bg-gradient-to-r from-yellow-600 to-yellow-400 text-black shadow-[0_4px_25px_rgba(234,179,8,0.5)] hover:shadow-[0_4px_35px_rgba(234,179,8,0.7)] active:scale-95 flex items-center justify-center gap-2"
              >
                 <Crown className="w-4 h-4 text-yellow-950" />
                 Adquirir Plan Premium
              </button>
              <button 
                 onClick={() => setMostrarUpsellRutas(false)}
                 className="mt-4 text-slate-500 hover:text-white text-xs font-bold uppercase transition-colors"
              >
                 Cerrar
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* BOTTOM SHEET: SELECTOR DE CILINDRAJE (40% INFERIOR) */}
      <AnimatePresence>
        {mostrarSelectorCC && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[150] bg-black/80 backdrop-blur-md flex items-end justify-center"
            onClick={() => setMostrarSelectorCC(false)}
          >
            <motion.div 
              initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }}
              transition={{ type: 'spring', damping: 25, stiffness: 200 }}
              className="w-full max-w-md bg-[#0a0a0a] border-t border-white/10 rounded-t-[40px] p-6 pb-20 flex flex-col items-center"
              onClick={e => e.stopPropagation()}
            >
              <div className="w-12 h-1 bg-white/10 rounded-full mb-8" />
              <h3 className="text-white font-black text-xl uppercase tracking-tighter mb-2">Filtro de Cilindraje</h3>
              <p className="text-slate-500 text-[10px] font-bold uppercase mb-8 tracking-widest text-center">Selecciona el tipo de motos permitidas</p>
              
              <div className="w-full flex flex-col gap-3">
                {[
                  { id: 'todos', label: 'Todos los CC Permitidos', icon: <RefreshCw className="w-5 h-5"/>, desc: 'Sin restricciones' },
                  { id: 'baja', label: 'Hasta 250cc', icon: <Navigation className="w-4 h-4"/>, desc: 'Motos de baja y media cilindrada' },
                  { id: 'media', label: '250cc a 500cc', icon: <MapPin className="w-5 h-5"/>, desc: 'Motos de cilindrada media' },
                  { id: 'alta', label: 'Mayor a 500cc', icon: <Navigation className="w-6 h-6"/>, desc: 'Exclusivo para alta cilindrada' }
                ].map((opt) => (
                  <button 
                    key={opt.id}
                    onClick={() => {
                        setRutaForm({...rutaForm, cilindraje: opt.id});
                        setMostrarSelectorCC(false);
                    }}
                    className={`w-full p-4 rounded-3xl border transition-all flex items-center gap-4 ${rutaForm.cilindraje === opt.id ? 'bg-primary-cyan/10 border-primary-cyan/40 scale-[1.02] shadow-[0_0_20px_rgba(0,168,255,0.1)]' : 'bg-transparent border-white/5 active:bg-white/5'}`}
                  >
                    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center border ${rutaForm.cilindraje === opt.id ? 'bg-primary-cyan text-bg-dark border-primary-cyan' : 'bg-slate-900 text-slate-500 border-white/5'}`}>
                        {opt.icon}
                    </div>
                    <div className="flex flex-col items-start">
                        <span className={`text-[13px] font-black uppercase leading-none ${rutaForm.cilindraje === opt.id ? 'text-white' : 'text-slate-300'}`}>{opt.label}</span>
                        <span className="text-[9px] font-bold text-slate-500 uppercase mt-1">{opt.desc}</span>
                    </div>
                  </button>
                ))}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
